import { MoreVert } from "@mui/icons-material";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { ReactElement, useState, MouseEvent } from "react";

import { generateCsv } from "./generateCsv";

export function DownloadDataButton<T extends object>({
  disabled,
  downloadableRows,
  fileName,
}: {
  disabled?: boolean;
  downloadableRows: [T, ...T[]];
  fileName: string;
}): ReactElement {
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  const handleDownloadCsv = async () => {
    const csv = generateCsv(downloadableRows);
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.addEventListener("click", () => {
      setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
    });
    a.click();
  };

  return (
    <>
      <IconButton onClick={handleOpenMenu} disabled={disabled}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        open={menuOpen}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
      >
        <MenuItem onClick={handleDownloadCsv}>Download Data</MenuItem>
      </Menu>
    </>
  );
}
